export default {
  filters: {
    capitalize: function(value) {
      if (!value) return '';

      value = value.toString();

      return value.charAt(0).toUpperCase() + value.slice(1);
    },

    currency: function(value) {
      value = parseFloat(value);

      if (typeof value !== 'number') return value;

      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      });

      return formatter.format(value);
    },

    date: function(value) {
      if (value != null && 'seconds' in value) {
        return new Date(value.seconds * 1000).toLocaleDateString();
      }
      return value;
    },

    fullname: function(value) {
      if (value != null && 'firstname' in value) {
        return `${value.firstname} ${value.lastname}`;
      }

      return value;
    },

    status: function(value) {
      let className;

      switch (value) {
        case 'en proceso':
          className = 'blue';
          break;
        case 'aprobada':
          className = 'green';
          break;
        case 'rechazada':
          className = 'red';
          break;
        case 'expirada':
          className = 'purple';
          break;
        default:
          className = 'gray';
          break;
      }

      return `<a class="btn btn-sm ${className} rounded text-white text-capitalize">${value}</a>`;
    },

    getTimeString: function(value) {
      let timeString;
      switch (value) {
        case 'meses':
          timeString = 'Mensual';
          break;
        case 'semanas':
          timeString = 'Semanal';
          break;
        case 'quincenas':
          timeString = 'Quincenal';
          break;
        case 'años':
          timeString = 'Anual';
          break;
        default:
          timeString = 'Mensual';
          break;
      }

      return timeString;
    }
  }
};
